module.exports = __webpack_public_path__ + "static/media/snack_icon.8d354284.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snack_icon.svg
// module id = 54
// module chunks = 0